import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface Props {
  open: boolean;
  title: string;
  message: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  isPending?: boolean;
}

export default function ConfirmDeleteDialog({
  open,
  title,
  message,
  onClose,
  onConfirm,
  isPending,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{ paper: { sx: { borderRadius: 3, minWidth: 360 } } }}
    >
      <DialogTitle sx={{ fontWeight: 700, fontSize: "1rem", pb: 0.5 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: "0.875rem" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          sx={{
            textTransform: "none",
            color: "#5C6B7A",
            "&:hover": { bgcolor: "#EDF1F7" },
          }}
        >
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={isPending}
          onClick={onConfirm}
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
